<template>
  <div>
    <Row>
      <div class="purchas">
        <Breadcrumb separator=">" :style="{ margin: '24px 0' }">
          <BreadcrumbItem>我的账户</BreadcrumbItem>
          <BreadcrumbItem>旅游卡中心</BreadcrumbItem>
          <BreadcrumbItem>旅游卡采购</BreadcrumbItem>
        </Breadcrumb>
        <div slot="title" class="cardTitle2">
          <p>分销商信息</p>
        </div>
        <div class="distributor">
          分销商:<span class="name">{{ corpname }}</span>
        </div>
        <div>
          <!-- 采购信息 -->
          <div class="purchasing">
            <div slot="title" class="cardTitle2">
              <p>旅游卡采购</p>
            </div>
            <Form
              ref="formItem"
              :model="formItem"
              :label-width="100"
              :rules="ruleValidate"
              style="width: 400px"
              label-position="left"
            >
              <FormItem label="旅游卡:" prop="present">
                <Select :label-in-value="true" @on-change="changeCard">
                  <Option
                    :value="item.value"
                    v-for="(item, index) in cardList"
                    :key="index"
                    >{{ item.label }}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="旅游卡单价:" prop="price">
                <Select v-model="formItem.price">
                  <Option
                    :value="item.value"
                    v-for="(item, index) in priceList"
                    :key="index"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="购买数量:" prop="total">
                <Input
                  v-model="formItem.total"
                  placeholder="请填写整数"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  style="margin-left: -100px"
                  type="primary"
                  @click="add('formItem')"
                  >加入采购清单</Button
                >
              </FormItem>
            </Form>
          </div>
          <!-- 订单信息 -->
          <div class="indent">
            <div class="title">订单信息</div>
            <div class="item">
              <span>分销商：{{ corpname }}</span>
              <span>分销商ID：{{ corpnameId }}</span>
            </div>
            <div class="tabel">
              <Table
                border
                :columns="historyColumns"
                :data="historyData"
              ></Table>
            </div>
            <div class="indentPeice">
              订单合计金额：￥<span>{{ monery }}</span
              >元
            </div>
            <Button class="btn" type="primary" @click="handleSubmit"
              >提交订单</Button
            >
          </div>
          <!-- 弹框 -->
          <Modal
            v-model="modal10"
            class-name="vertical-center-modal"
            footer-hide
            :mask-closable="false"
            :styles="{ top: '300px', width: '460px', height: '328px' }"
          >
            <div
              class="box"
              style="
                text-align: center;
                padding-top: 80px;
                padding-bottom: 28px;
              "
            >
              <p style="font-size: 20px; color: #333333">
                <img
                  style="width: 27px; height: 18px"
                  src="@/assets/icon_cg.png"
                  alt=""
                />
                你的订单已生成成功
              </p>
              <p
                style="
                  font-size: 12px;
                  color: #333333;
                  margin-top: 16px;
                  margin-bottom: 48px;
                "
              >
                订单号: <span>{{ dingdanhao }}</span>
              </p>
              <p style="font-size: 12px; color: #333333">
                请通过下方的在线支付链接进行支付
              </p>
              <p
                style="
                  font-size: 12px;
                  color: #333333;
                  margin-top: 8px;
                  cursor: pointer;
                "
              >
                <a :href="url" target="_blank">{{ url }}</a>
              </p>
              <p
                style="
                  font-size: 12px;
                  color: #999999;
                  margin-top: 32px;
                  margin-bottom: 28px;
                  cursor: pointer;
                "
                @click="toGiftCardCg"
              >
                查看全部订单
              </p>
            </div>
          </Modal>
        </div>
      </div>
      <loading v-if="spinShow"></loading>
    </Row>
    <Modal
      v-model="modal11"
      class-name="vertical-center-modal"
      footer-hide
      :mask-closable="false"
      :styles="{ top: '100px', width: '850px', height: '800px' }"
    >
      <div class="agreement">
        <div class="title">退款须知</div>
        <div class="rule">
          <div class="text" v-html="agreement"></div>
        </div>
        <div class="btn">
          <Button
            type="primary"
            style="width: 100px; height: 40px"
            @click="modal11 = false"
          >
            确认
          </Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="modal2" width="300">
      <div style="text-align: center; height: 100px; line-height: 100px">
        <p style="font-size: 16px">你确定要删除吗?</p>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="success">确定</Button>
        <Button @click="modal2 = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      agreement: "", //协议
      corpname: "",
      spinShow: true,
      formItem: {
        usid: "",
        present: "",
        price: "",
        total: "",
      },
      cardId: "",
      dingdanhao: "", //订单号
      url: "",
      monery: 0,
      modal10: false,
      modal11: false,
      modal2: false,
      _index: "",
      historyData: [], // 表格数据
      historyColumns: [
        {
          title: "序号",
          align: "center",
          key: "value",
          render: (h, params) => {
            return h("span", params.index + 1);
          },
        },
        {
          title: "商品ID",
          align: "center",
          key: "usid",
        },
        {
          title: "商品名",
          align: "center",
          key: "present",
        },
        {
          title: "相关说明",
          minWidth: 30,
          align: "center",
          render: (h, params, index) => {
            return h("span", [
              h(
                "span",
                {
                  class: "hover_span",
                  style: {
                    marginRight: "10px",
                  },
                  on: {
                    click: () => {
                      this.goGroupEdit(params.row);
                    },
                  },
                },
                "退款规则"
              ),
            ]);
          },
        },
        {
          title: "单价",
          align: "center",
          key: "price",
        },
        {
          title: "采购数量",
          key: "total",
          align: "center",
        },
        {
          title: "商品总金额",
          key: "zm",
          align: "center",
        },
        {
          title: "操作",
          // key: "cz",
          minWidth: 30,
          align: "center",
          render: (h, params, index) => {
            return h("span", [
              h(
                "span",
                {
                  class: "hover_span",
                  style: {
                    marginRight: "10px",
                    color: "#FF6C5F",
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    },
                  },
                },
                "移除"
              ),
            ]);
          },
        },
      ],
      // 分销商信息
      usid: [],
      // 旅游卡
      cardList: [],
      // 旅游卡单价
      priceList: [],
      corpnameId: "",
      ruleValidate: {
        present: [
          {
            required: true,
            message: "请选择旅游卡类型",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: "请选择旅游卡价格",
            trigger: "change",
          },
        ],
        total: [
          {
            required: true,
            message: "请输入购买数量",
            trigger: "blur",
          },
          {
            message: "请输入整数",
            trigger: "change",
            pattern: /^[1-9]\d*$/,
          },
        ],
      },
    };
  },
  methods: {
    // 提交订单
    async handleSubmit() {
      if (this.formItem.total === "") {
        this.$Message.error("请输入采购数量!");
        return;
      } else if (!this.historyData.length) {
        this.$Message.error("请先加入采购清单");
        return;
      } else if (this.historyData[0].total !== this.formItem.total) {
        this.$Message.error("购买数量已修改,请重新加入采购清单");
        return;
      } else if (this.historyData[0].price !== this.formItem.price) {
        this.$Message.error("旅游卡单价已修改,请重新加入采购清单");
        return;
      } else {
        this.$Spin.show();
        setTimeout(() => {
          this.$Spin.hide();
        }, 500);
        const usid = sessionStorage.getItem("usid");
        let obj = {
          access_token: sessionStorage.getItem("name"),
          cardId: this.cardId,
          usid: usid,
          price: this.formItem.price,
          total: this.formItem.total,
          url: window.location.protocol + "//" + window.location.host,
        };

        const res = await this.$http.post(
          this.baseURL +
            "/tourcard/tourCardOrder/v1/saveEcardOrder?access_token=" +
            sessionStorage.getItem("name"),
          obj
        );
        // 下单成功
        if (res.data.code === 200) {
          this.dingdanhao = res.data.data.order.batchid;
          this.url = res.data.data.url;
          this.modal10 = true;
          this.historyData = [];
        } else {
          this.$Message.error({
            content: res.data.msg,
            duration: 3,
          });
        }
      }
    },
    // 选择卡片
    async changeCard(data) {
      this.historyData = [];
      this.priceList = [];
      this.formItem.total = "";
      this.formItem.present = data.label;
      const res = await this.$api.get(
        this.baseURL +
          `/tourcard/tourcard/v1/get/${
            data.value
          }?access_token=${sessionStorage.getItem("name")}`
      );
      if (res.code === 200) {
        this.priceList.push({
          value: String(res.data.price),
          label: res.data.price + "元",
        });
        this.formItem.usid = data.value;
        this.formItem.present = data.label;
        this.cardId = res.data.id;
      }
      this.$nextTick(() => {
        this.formItem.price = this.priceList[0].value;
      });
    },
    // 加入采购清单
    add(name) {
      this.historyData = [];
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formItem.zm =
            Number(this.formItem.total) * Number(this.formItem.price);
          this.formItem.zm = Math.round(this.formItem.zm * 100) / 100;
          this.monery = Number(this.formItem.zm);
          const newObj = JSON.parse(JSON.stringify(this.formItem));
          console.log(newObj);
          this.historyData.push(newObj);
        } else {
          console.log("请填写完整购买信息");
        }
      });
    },
    // 使用说明
    async goGroupEdit() {
      this.modal11 = true;
      let obj = {
        cardId: this.cardId,
        usid: sessionStorage.getItem("userName"),
      };

      const res = await this.$http.post(
        this.baseURL +
          `/tourcard/tourcardrule/v1/getRuleByUser?access_token=${sessionStorage.getItem(
            "name"
          )}`,
        obj
      );
      if (res.data.code === 200) {
        if (res.data.data) {
          this.$nextTick(() => {
            this.agreement = res.data.data.descriptionStr;
          });
        } else {
          this.agreement = "暂无规则信息";
        }
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 移除
    remove(data) {
      this.modal2 = true;
      this._index = data._index;
    },
    success() {
      this.modal2 = false;
      this.historyData.splice(this._index, 1);
      if (this.historyData.length === 0) {
        this.$Message.info("删除成功!");
      }
    },
    // 查看全部订单
    toGiftCardCg() {
      this.$router.push("./travelCardOrder");
    },
  },
  created() {
    this.spinShow = false;
  },
  async mounted() {
    this.corpname = sessionStorage.getItem("corpname");
    this.corpnameId = sessionStorage.getItem("usid");
    this.spinShow = false;

    let obj = {
      type: 2,
      periodType: 9,
      usePeriod: -1,
      usid: sessionStorage.getItem("userName"),
    };

    const res = await this.$http.post(
      this.baseURL +
        `/tourcard/tourcard/v1/listByCustom?access_token=${sessionStorage.getItem(
          "name"
        )}`,
      obj
    );
    if (res.data.code === 200) {
      res.data.data.items.forEach((item) => {
        this.cardList.push({
          value: item.id,
          label: item.name,
        });
      });
    } else {
      this.$message.error(res.data.msg);
    }
  },
};
</script>
<style lang="less" scoped>
.purchas {
  .distributor {
    font-size: 14px;
    color: #505a6e;
    padding-bottom: 24px;
    margin-bottom: 16px;
    border-bottom: 1px solid #e6e6e6;
    .name {
      font-size: 14px;
      color: #333;
      margin-left: 16px;
    }
  }
  //   采购信息
  .purchasing {
    border-bottom: 1px solid #ccc;
    padding-bottom: 36px;
    .title {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .distributor {
      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #505a6e;
      }
    }
    .present {
      padding: 24px 0;
      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #505a6e;
      }
    }
    .price {
      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #505a6e;
      }
    }
    .num {
      padding: 24px 0;
      .title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #505a6e;
      }
    }
  }
  //   订单信息
  .indent {
    .title {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    .item {
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      span {
        margin-right: 15px;
      }
    }
    .tabel {
      margin-top: 12px;
      .paging {
        text-align: center;
        margin-top: 12px;
      }
    }
    .indentPeice {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      padding-top: 36px;
      padding-bottom: 24px;
    }
    .btn {
      margin-bottom: 30px;
    }
  }
  //   弹框
  // ::v-deep .ivu-modal {
  //   background-color: red;
  // }
}
.agreement {
  .rule {
    margin: 0 auto;
    padding: 0 15px;
    width: 85%;
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
    border: 1px solid #ccc;
  }
  .title {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #2670ff;
    letter-spacing: 0;
    text-align: center;
    padding: 30px 0;
  }
  .btn {
    padding-top: 30px;
    text-align: center;
    padding-bottom: 40px;
  }
  /*兼容IE*/
  .rule {
    scrollbar-face-color: #4581f8; /*移动滑块颜色*/
    scrollbar-shadow-color: #4581f8; /*移动滑块边框颜色*/
    scrollbar-track-color: #e6e6e6; /*背景颜色*/
    scrollbar-arrow-color: #e6e6e6; /*箭头颜色*/
  }
  .rule::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #e6e6e6;
  } /* 滚动条的滑轨背景颜色 */
  .rule::-webkit-scrollbar {
    width: 6px;
    background-color: #e6e6e6;
  }

  .rule::-webkit-scrollbar-thumb {
    background-color: #4581f8;
  } /* 滑块颜色 */
}
</style>
